module.exports = __webpack_public_path__ + "03_long_black.60cd31f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/03_long_black.png
// module id = ihMX
// module chunks = 0